import ApiClient from '@/api/ApiClient';

import type {
  Department,
  DepartmentSyncRequest,
} from '../models';

export type GetDepartmentsRequest = {
  limit?: number;
  managerId?: string;
  populated?: boolean;
  rootId?: string;
};

export class DepartmentClient {
  apiClient: ApiClient;

  constructor(apiClient?: ApiClient) {
    this.apiClient = apiClient || ApiClient.instance;
  }

  getDepartments(request: GetDepartmentsRequest = {}): Promise<Department[]> {
    const { ...params } = request;
    return this.apiClient.get({
      path: '/api/departments',
      params,
    });
  }

  createDepartment(request: { body?: Department; } = {}): Promise<void> {
    const { body } = request;
    return this.apiClient.post({
      path: '/api/departments',
      body,
    });
  }

  syncDepartments(request: { body?: DepartmentSyncRequest; } = {}): Promise<void> {
    const { body } = request;
    return this.apiClient.post({
      path: '/api/departments/sync',
      body,
    });
  }

  getManagers(request: { id: string; }): Promise<void> {
    const { id } = request;
    return this.apiClient.get({
      path: `/api/departments/user/${id}`,
    });
  }

  getDepartment(request: { id: string; }): Promise<void> {
    const { id } = request;
    return this.apiClient.get({
      path: `/api/departments/${id}`,
    });
  }

  updateDepartment(request: { id: string; body?: Department; }): Promise<void> {
    const { id, body } = request;
    return this.apiClient.put({
      path: `/api/departments/${id}`,
      body,
    });
  }

  deleteDepartment(request: { id: string; }): Promise<void> {
    const { id } = request;
    return this.apiClient.del({
      path: `/api/departments/${id}`,
    });
  }
}

export default DepartmentClient;
